import React from 'react'
import ContentBrandHeroCarousel from '../../../components/ContentBrandHeroCarousel'
import moment from 'moment'

const PromoCarouselWidget = ({ items }) => {
  const currentDate = moment()

  const slides = items
    .filter((item) => {
      if (item.liveDate && currentDate.isBefore(item.liveDate)) return false

      if (item.expiryDate && moment(item.expiryDate).isBefore(currentDate))
        return false

      return true
    })
    .map((item) => ({
      path: item.link,
      image:
        item.image &&
        item.image.widgets &&
        item.image.widgets[0] &&
        item.image.widgets[0].crops &&
        item.image.widgets[0].crops[0] &&
        item.image.widgets[0].crops[0].src,
      alt: item.altText
    }))

  return <ContentBrandHeroCarousel controls mouseevents slides={slides} />
}

export default PromoCarouselWidget
